const firebase = require("firebase/app");
require("firebase/firestore");

import { getLatLong, computeDistance } from "../../utils/maps/maps";

const verifyLoyer = (data, loyer_type, loyer_value, callback) => {
  if (loyer_type == "Par mois") {
    if (
      data.loyer_mensuel >= loyer_value[0] &&
      data.loyer_mensuel <= loyer_value[1]
    )
      callback();
  } else if (loyer_type == "Par an") {
    if (
      data.loyer_mensuel * 12 >= loyer_value[0] &&
      data.loyer_mensuel * 12 <= loyer_value[1]
    )
      callback();
  } else if (loyer_type == "Par m²/mois") {
    if (
      data.loyer_mensuel / data.surface >= loyer_value[0] &&
      data.loyer_mensuel / data.surface <= loyer_value[1]
    )
      callback();
  } else if (loyer_type == "Par m²/an") {
    if (
      (data.loyer_mensuel * 12) / data.surface >= loyer_value[0] &&
      (data.loyer_mensuel * 12) / data.surface <= loyer_value[1]
    )
      callback();
  }
};

const state = {
  biens: []
};

const mutations = {
  ADD_BIENS(state, value) {
    state.biens.push(value);
  },
  CLEAR_BIENS(state) {
    state.biens = [];
  }
};

const getters = {
  getBiens: state => {
    return state.biens;
  }
};

const actions = {
  async fetchAll({ commit }) {
    let db = firebase.firestore().collection("biens");
    commit("CLEAR_BIENS");
    db.get().then(snap => {
      snap.docs.map(doc => {
        commit("ADD_BIENS", doc.data());
      });
    });
  },
  async fetchBiens({ commit }, arg) {
    if (!arg) return;

    commit("CLEAR_BIENS");
    let db = firebase.firestore().collection("biens");

    if (arg.selected != null && arg.selected.length != 0) {
      db = db.where("properties", "array-contains-any", arg.selected);
    }

    // Position search
    let origin = undefined;
    if (arg.place) {
      await getLatLong(arg.place.Description).then(res => {
        origin = res;
      });
    }

    return db.get().then(snap => {
      if (origin == undefined) {
        snap.docs.map(doc => {
          verifyLoyer(doc.data(), arg.type, arg.loyer, () =>
            commit("ADD_BIENS", doc.data())
          );
        });
      } else {
        snap.docs.map(doc => {
          let a = doc.data();
          if (a.position) {
            computeDistance(
              {
                lat: origin.data.lat,
                long: origin.data.lng
              },
              {
                lat: a.position.latitude,
                long: a.position.longitude
              }
            ).then(r => {
              if (r.status == "SUCCESS" && r.data / 1000 < arg.distance) {
                verifyLoyer(doc.data(), arg.type, arg.loyer, () =>
                  commit("ADD_BIENS", doc.data())
                );
              }
            });
          }
        });
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
